import { useState, useEffect } from 'react';
import getClient from '@/lib/pusher';
import useLoadUser from './useLoadUser';

let globalClient = null;
let clientPromise = null;

const usePusher = () => {
  const [client, setClient] = useState(null);
  const { isLoaded } = useLoadUser();

  useEffect(() => {
    const loadPusher = async () => {
      if (!clientPromise) {
        clientPromise = getClient().then((result) => {
          globalClient = result;
          return globalClient;
        });
      }

      const loadedClient = await clientPromise;
      setClient(loadedClient);
    };

    if (isLoaded && !client) {
      loadPusher();
    }
  }, [isLoaded, client]);

  return client;
};

export default usePusher;
